<template>


	<div class="app-principal">	
		<div class="app-topo">
            <top-bar :title="titulo" exibeVoltar="true" historyback="true" />
        </div>
		<div class="app-centro-sem-rodape">
            <div class="div-titulo">
                <div class="label-titulo"><center>{{relatorio}}</center></div>
                <div class="label-titulo" style="float: left; width: 50vw; text-align: center;">Vencimento</div>
                <div class="label-titulo" style="float: left; width: calc(50vw - 1px); border-left: 1px solid  var(--dark-color);  text-align: center;">Valor</div>
            </div>
            
            <div class="lista2">
                <div class="item-lista2"  v-for="item in cpcr" v-bind:key="item.DATA_VCT">
                    <div style="float: left; width: calc(50vw); text-align: center;">{{ item.DATA_VCT }}</div>
                    <div style="float: left; width: calc(50vw - 86px); text-align: right;  border-left: 1px solid  #CECECE;
                        padding-right: 15px;">{{ item.VALOR | toCurrency }}</div>
                    <div style="float: left; width: 50px;"><button class="botao-pesquisa" 
                        @click="detalhar(encodeURIComponent(item.DATA_VCT))"><i class="fas fa-search fa-lg"></i></button></div>
                </div>
            </div>       
            
        </div>
	</div>


</template>


<script>

import TopBar from '@/components/layout/TopBar.vue';
import request from '@/services/services.js';

export default {
    name: 'ContasAPagarReceber',
    props: ['tipo', 'periodo'],
    components: {TopBar},
    data() {
        return{
            titulo: ' ',
            relatorio: '',
            cpcr : []
        };
    },

    methods: {
        detalhar(datavct){
            this.$router.push(`/detalhamentocpcr/${this.tipo}/${datavct}`);
        }
    },

    mounted: function () {

        var tipoPeriodo = '';

        if(this.tipo=='cp'){
            this.titulo='Contas a pagar';
        } else if(this.tipo=='cr'){
            this.titulo='Contas a receber';
        }

        if (this.periodo=='30DDmenos') {
           tipoPeriodo='30DD-' ;
           this.relatorio="Vencidos a mais de 30 dias";
        } else if (this.periodo=='30Dmenos') {
           tipoPeriodo='30D-' ;
           this.relatorio="Vencidos a menos de 30 dias";
        }  else if (this.periodo=='30Dmais') {
           tipoPeriodo='30D%2B' ;
           this.relatorio="A vencer nos próximos 30 dias";
        }  else if (this.periodo=='30DDmais') {
           tipoPeriodo='30DD%2B' ;
           this.relatorio="A vencer após 30 dias";
        } 
        

                    


        request(this, 'GET',
            'Mobile_CP_CR',
            `tipo=${this.tipo}&periodo=${tipoPeriodo}&rootProperty=cpcr`)
        .then(res => {
            if(res){
                this.cpcr=res.cpcr;
            }
        });

    },
}
</script>


<style scoped>

.lista2{
    overflow-x: auto;
    overflow-y: auto;
    height: calc(100vh - 150px);
    width: calc(100%);
}

    .item-lista2{
        height: 50px;
        border-top: 1px solid #CECECE;
        line-height: 50px;
        background-color: #fafafa;
        font-size: 16px;
        width: 100%;
    }

    .div-titulo{
        width: 100vw;
        height: 85px;
        background-color: var(--primary-color);
        color: white;
        border-bottom: 1px solid  var(--dark-color);
    }

    .label-titulo {
        line-height: 42px;
        border-bottom: 1px solid  var(--dark-color);
        height: 42px;
    }


</style>